<div>
  <p>{{ issue.issue.message }}</p>
  <form [formGroup]="failbackResourceFormModel" (ngSubmit)="submitForm()" class="form-controls">
    <div class="arpio-radio-container">
      <label class="arpio-radio">
        <input id="use-new-resource" type="radio" formControlName="useNewResource" value="false" />
        <span class="radio-label strong-text">Try again with the existing resource</span>
        <div>
          Select this option if you have fixed the issue with {{ resourceTypeString }} {{ resourceName }}
          and want to try again.
        </div>
      </label>
      <div class="margin-top"></div>
      <label class="arpio-radio">
        <input id="use-new-resource" type="radio" formControlName="useNewResource" value="true" />
        <span class="radio-label strong-text">Use a new {{ resourceTypeString }}</span>
        <div>
          Select this option to use a new {{ resourceTypeString }} in the primary environment
          <em>({{ sourceAwsAccountId }}/{{ sourceRegion }})</em>. Paste the <em>ID</em> of the new
          {{ resourceTypeString }} you would like to use below.
        </div>
      </label>
    </div>
    <div *ngIf="useNewResource">
      <input
        id="new-resource-id"
        type="text"
        formControlName="newResourceId"
        class="arpio-input margin-left"
        autofocus
        placeholder="i-01ff2d1..."
      />
      <p *ngIf="showIdHint" class="double-margin-left">
        Hmm, that does not look like a valid ID for resource type: {{ resourceTypeString }}.
      </p>
    </div>
    <div class="flex-center-row control-header">
      <div class="spacer"></div>
      <button busy-button class="arpio-button" type="submit" [disabled]="notReadyToSave" [busy]="saving">SAVE</button>
    </div>
  </form>
</div>
